import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useViewport from './useViewport';

const useViewportType = ({ breakpointsMobile, breakpointsDesktop }) => {
  const { width } = useViewport();

  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  const isClient = typeof window !== 'undefined';

  const propertyValidation = ({ property, errorMessage }) => {
    if (!property || (Array.isArray(property) && property.length === 0)) {
      throw new Error(errorMessage);
    }

    return true;
  };

  propertyValidation({
    property: breakpointsMobile,
    errorMessage: '@autovia-uk/polaris-components-viewportchecker => useViewportType(): Property breakpointsMobile is not correct',
  });
  propertyValidation({
    property: breakpointsDesktop,
    errorMessage: '@autovia-uk/polaris-components-viewportchecker => useViewportType(): Property breakpointsDesktop is not correct',
  });

  useEffect(() => {
    if (!isClient) return;

    const isWidthInRange = ({ range }) => range.reduce((accumulator, curr) => accumulator && width >= curr.min && width <= curr.max, true);

    setIsMobile(isWidthInRange({ range: breakpointsMobile }));

    setIsDesktop(isWidthInRange({ range: breakpointsDesktop }));
  }, [isClient, width, breakpointsMobile, breakpointsDesktop]);

  return { isMobile, isDesktop };
};

useViewportType.propTypes = {
  breakpointsDesktop: PropTypes.arrayOf(
    PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }),
  ).isRequired,
  breakpointsMobile: PropTypes.arrayOf(
    PropTypes.shape({
      min: PropTypes.number.isRequired,
      max: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default useViewportType;
